import {FAQList} from './FAQList';
/**
 * Created by FengqiZhang on 27/3/17.
 */
export class FAQItem {
  public open = false;
  public $icon: JQuery;
  public $body: JQuery;

  constructor(public faqList: FAQList, public $section: JQuery) {
    // $section.attr('data-state',this.open ? 'open' : 'closed');
    // this.$icon = $section.children('.accordion-head').children('i');
    // this.$body = $section.children('.accordion-body');
    if (this.open) {
      $section.attr('open', 'true');
    }
    // $section.attr('open', this.open ? 'open' : 'closed');
    this.$icon = $section.children('summary').children('i');
    this.$body = $section.children('article');
    this.init();
  }

  public init() {
    // this.$section.children('.accordion-head').click((e) => {
    this.$section.children('summary').click(e => {
      e.preventDefault();
      if (!this.open) {
        this.faqList.closeAll();
      }
      this.open = !this.open;
      this.refresh();
      return false;
    });
  }
  public refresh() {
    // this.$section.attr('data-state',this.open ? 'open' : 'closed');
    // this.$icon.attr('class',this.$icon.attr(`data-${this.open ? 'open' : 'close'}`));
    // if(this.open)
    //   this.$body.slideDown();
    // else
    //   this.$body.slideUp();
    if (this.open) {
      this.$section.attr('open', '');
    } else {
      this.$section.removeAttr('open');
    }
  }
}
